import React from "react";
import { Row, Col } from "react-bootstrap";

const DeaLicenseItems = ({ deaItems, onChangeHandler, selectedItems }) => {
  return (
    <React.Fragment>
      {deaItems.length ? (
        <div className="dt-each mb-2">
          {/* <div className="mb-1"><strong>DeaLicenses</strong></div> */}
          {deaItems.map((item, i) => {
            let unverifiedlabel = "";
            let unverifiedBtnClass = "";
            let label = "";
            let btnClass = "";
            if (!item.DEA_Verified) {
              unverifiedlabel = "Unverified";
              unverifiedBtnClass = "bg-info";
            }

            return (
              <Row key={i}>
                <Col>
                  <input
                    type="checkbox"
                    id={`psv_item_dea_${item.provider.toString()}_${i}`}
                    checked={
                      selectedItems.some(
                        (selectedItem) =>
                          selectedItem.ProviderID === item.provider &&
                          selectedItem.DeaLicenses &&
                          selectedItem.DeaLicenses.includes(item._id)
                      ) ||
                      (item.submitted_to_verify
                        ? item.submitted_to_verify
                        : false)
                    }
                    onChange={(e) => onChangeHandler(e, "DeaLicenses", item)}
                    disabled={
                      item.submitted_to_verify
                        ? item.submitted_to_verify
                        : false
                    }
                  />
                  <label
                    htmlFor={`psv_item_dea_${item.provider.toString()}_${i}`}
                  >
                    <span className="ml-1">DEA Licenses</span>{" "}
                    {unverifiedlabel ? (
                      <span className={`badge ${unverifiedBtnClass}`}>
                        {unverifiedlabel}
                      </span>
                    ) : null}{" "}
                    {label ? (
                      <span className={`badge ${btnClass}`}>{label}</span>
                    ) : null}{" "}
                    {item.submitted_to_verify ? (
                      <span className="badge bg-secondary">In Process</span>
                    ) : null}
                  </label>
                </Col>
              </Row>
            );
          })}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default DeaLicenseItems;
